import { render } from "./ConsultantsPage.vue?vue&type=template&id=32c8439b&scoped=true"
import script from "./ConsultantsPage.vue?vue&type=script&lang=js"
export * from "./ConsultantsPage.vue?vue&type=script&lang=js"

import "./ConsultantsPage.vue?vue&type=style&index=0&id=32c8439b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c8439b"]])

export default __exports__